<template>
  <div class="row">
    

    <div class="col">
      <h3>Ordenar</h3>
      
      
      <draggable
        :list="categories"
        :disabled="!enabled"
        item-key="id"
        class="list-group"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
      >
        <template #item="{ element }">
          <div  class="list-group-item" :class="element.enabled ? 'text-primary':'text-muted'">
            {{element.id}}--{{ element.name }}
            <span class="float-end">s/{{element.price}}.00</span>
          </div>
        </template>
      </draggable>
    </div>
<!-- 
    <ul>
      <ol v-for="category in categories" :key="category.id">{{category.id}}</ol>
    </ul> -->
    <button @click="sort_list" class="btn btn-success">Guardar orden de listado</button>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from 'axios';
import {ref,computed} from 'vue';
import {useToast} from 'vue-toastification';
import {useStore} from 'vuex';

export default {
  name:"plateEdit",
  props:['category'],
  emits:['check'],
  components: {
    draggable
  },
  setup(props,{emit}){
    const store = useStore()
    const toast = useToast()
    const v_user = computed(()=>store.state.login.v_user)

    const enabled = ref(true)
 
    const dragging = ref(false)

    const categories = ref(props.category.all_plates.slice())


    const sort_list = () =>{

      let config = {
            headers: {
            'Authorization': 'Bearer ' + v_user.value.accessToken,
            'Accept':'application/json'
            }
        }

      axios
        .post(store.state.v_url_global+'/plates/sort-list',{
            plates:categories.value
        },config).then(() => {
            store.dispatch('v_action_categories').then(()=>{
                emit('check',props.category.id);
                toast.success('Lista actualizada con exito');    
                })
            })
            .catch((error) => {
                toast.error(error);
            });
    }
    const checkMove = (e) => {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    }

    return{
      categories,
        sort_list,
        enabled,
        
        dragging,
        checkMove,
    }
  },
 
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.not-draggable {
  cursor: no-drop;
}
</style>